import { Grid, Skeleton } from "@mantine/core";
import PageWrapperSkeleton from "../common/PageWrapperSkeleton";
import OrganizationCardSkeleton from "../organizations/OrganizationCardSkeleton";
import OrganizationSmallCardSkeleton from "../organizations/OrganizationSmallCardSkeleton";

const HomePageOrgsSkeleton = () => {
  return (
    <>
      <PageWrapperSkeleton>
        <Grid>
          {Array.from(Array(8).keys()).map((organization, index) => (
            <Grid.Col span={12} md={12} lg={6} p={0} key={index}>
              <div className="hidden lg:block">
                <OrganizationCardSkeleton className="m-2" />
              </div>
              <div className="block lg:hidden">
                <OrganizationSmallCardSkeleton className="m-2" />
              </div>
            </Grid.Col>
          ))}
        </Grid>
      </PageWrapperSkeleton>
      <div className="flex justify-center my-[54px]">
        <Skeleton height={50} width={149} />
      </div>
    </>
  );
};

export default HomePageOrgsSkeleton;
